import { completeName, i18n, uppercaseInitials } from "utils";

export const normalizeDataRelative = (payload: any) => {
  const data = payload?.data?.item;
  return data ? {
    ...data,
    name: completeName(data.firstName, data.middleName, data.lastName),
    initialsName: uppercaseInitials(data.firstName, data.middleName, data.lastName),
  } : null;
};

export const normalizeDataRelatives = (payload: any) => {
  const data = payload?.data?.item?.items;
  return data ? data.map((item: any) => ({
    ...item,
    ...item.userName,
    id: item.userId,
    relation: item.relationship?.code ?? '',
  })) : [];
};

export const normalizeDataRelativeAction = (payload: any) => {
  const data = payload.data?.item?.items;
  return data.map((item: any) => ({
    ...item,
    actionType: i18n(item.actionType),
    destinationNumber: item.payload.destination_call_number,
  }));
};

export const updateRelatives = (data: any, meta: any) => {
  const newData = data.map((item: any) => {
    if (item.relationId === meta.relationId) {
      return {
        ...item,
        relationship: { ...meta.relationship },
      };
    }
    return item;
  });
  return newData;
}
